module.exports = __webpack_public_path__ + "img/bg-header.3305d595.png";